import React from 'react';
import FormRow from '../../../../common/formComponents/FormRow/FormRow';
import DatePickerField from '../../../../common/formComponents/DatePickerField/DatePickerField';
import { getInputOptions } from '../../utils/getInputOptions';
import { fieldNames } from '../constants';
import styles from '../HouseAcceptanceNoticeForm.module.scss';

const DatePickerRow = ({ form }) => {
  return (
    <FormRow rowType="field">
      <DatePickerField
        form={form}
        label="Плановый период приемки"
        name={fieldNames.rangePicker}
        options={getInputOptions({
          requiredErrMsg: 'Выберите период примки',
          fieldType: 'array',
          initialValue: [],
        })}
        inputProps={{
          className: styles.picker,
          dropdownClassName: styles.pickerDropdown,
        }}
      />
    </FormRow>
  );
};

export default DatePickerRow;
